import { RootState } from 'store';

const SahClientServicesState = (state: RootState) => state.supportAtHome.clientServices;

export const selectSahClientServices = (state: RootState) => SahClientServicesState(state).rows;
export const selectSahClientServicesGrouped = (state: RootState) => SahClientServicesState(state).grouped;

export const selectLoading = (state: RootState) => SahClientServicesState(state).loading;
export const selectErrorResponse = (state: RootState) => SahClientServicesState(state).error;
export const selectUploadError = (state: RootState) => SahClientServicesState(state).uploadError;
